/* ============================================================
   Bottom tab bar — cart count badge
   ------------------------------------------------------------
   theme.js owns the cart. It publishes the running count on
   window.__zetseCartCount and fires a 'zetse:cart' event every
   time the count changes — including the optimistic bump the
   instant ADD is tapped, before the network answers. This just
   listens, so the badge moves at the same moment the header one
   does.

   Previously this file wrapped window.fetch and inferred the
   count from cart requests, which meant the badge could only
   move once the response came back.
   ============================================================ */
(function () {
  'use strict';

  var badges = document.querySelectorAll('[data-bnav-count]');
  if (!badges.length) return;

  function paint(n) {
    if (typeof n !== 'number' || !isFinite(n) || n < 0) return;
    Array.prototype.forEach.call(badges, function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n <= 0;
    });
  }

  document.addEventListener('zetse:cart', function (e) {
    if (e && e.detail) paint(e.detail.item_count);
  });

  /* theme.js runs first and its /cart.js may already have landed */
  if (typeof window.__zetseCartCount === 'number') paint(window.__zetseCartCount);

  /* Belt and braces for a page where theme.js never ran */
  setTimeout(function () {
    if (typeof window.__zetseCartCount === 'number') return;
    if (typeof window.fetch !== 'function') return;
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) paint(cart.item_count); })
      .catch(function () {});
  }, 1500);
})();